import React, { Component, createRef } from "react";
// // Editable
import BootstrapTable from "react-bootstrap-table-next";

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Table,
} from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import { useState } from "react";
import { withTranslation } from "react-i18next";

class DataEntryEditOutwardStock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validation: "",
      editRowIndex: -1,
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);

    this.products2 = [
      {
        id: "01",
        categories: "HPHT",
        weight: 1.50,
        pieces: 1,
        inward: "",
      },
      {
        id: "02",
        categories: "HPHT",
        weight: 1.50,
        pieces: 1,
        inward: "",
      },
      {
        id: "03",
        categories: "LPHT",
        weight: 1.50,
        pieces: 1,
        inward: "",
      },
      {
        id: "04",
        categories: "REAL",
        weight: 1.50,
        pieces: 1,
        inward: "",
      },
    ];
  }

  handleSubmit(e) {
    e.preventDefault();

    const modifiedV = { ...this.state.validation };

    this.setState({ validation: modifiedV });
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {

    this.columns2 = [
      {
        dataField: "id",
         text: `${this.props.t("Sr.No.")}`,
        footer: `${this.props.t("Total")}`,
      },
      {
        dataField: "categories",
        text: "Categories",
        footer: "",
      },
      {
        dataField: "weight",
        text: `${this.props.t('Weight / Carat')}`,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2) + " CT",
      },
      {
        dataField: "pieces",
        text:`${this.props.t('Pieces')}`,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
      },
      {
        dataField: "inward",
        text: `${this.props.t('Inward Remarks')}`,
        footer: "",
      },
      {
        dataField: "outward",
        text: "Outward Remarks",
        footer: "",
      },
    ];
   
    document.title = "data entry person";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem="Manage Stock - Outward Stock" />
            <Card className="px-lg-3 px-0 py-4">
              <Formik
                enableReinitialize={true}
                initialValues={{
                  stockID: (this.state && this.state.stockID) || "",
                  partyCode: (this.state && this.state.partyCode) || "",
                  unitName: (this.state && this.state.unitName) || "",
                  weight: (this.state && this.state.weight) || "",
                  pieces: (this.state && this.state.pieces) || "",
                  graderName: (this.state && this.state.graderName) || "",
                  inwardnotes: (this.state && this.state.inwardnotes) || "",
                  outwardnotes: (this.state && this.state.outwardnotes) || "",
                }}
                validationSchema={Yup.object().shape({
                  attachment: Yup.mixed()
                    .nullable()
                    .notRequired()
                    .test(
                      "FILE_SIZE",
                      "Uploaded file is too big.",
                      value => !value || (value && value.size <= FILE_SIZE)
                    )
                    .test(
                      "FILE_FORMAT",
                      "Uploaded file has unsupported format.",
                      value =>
                        !value ||
                        (value && SUPPORTED_FORMATS.includes(value.type))
                    ),
                  stockID: Yup.string().required("This Value is Required"),
                  partyCode: Yup.string().required("This Value is Required"),
                  unitName: Yup.string().required("This Value is Required"),
                  weight: Yup.string().required("This Value is Required"),
                  pieces: Yup.string().required("This Value is Required"),
                  graderName: Yup.string().required("This Value is Required"),
                  inwardnotes: Yup.string().required("This Value is Required"),
                  outwardnotes: Yup.string().required("This Value is Required"),
                })}
                onSubmit={values => {}}
              >
                {({ errors, status, touched, values }) => (
                  <Form className="needs-validation">

                  <div className="d-lg-flex d-block justify-content-between">
                  <div>
                    <h4 className="pb-3 text-black fw-bold">Edit Outward Stock</h4>
                    </div>
                    {/* <div>
                      <label htmlFor="date" className="pe-2 fs-5 fw-bold text-black">Date:</label>
                      <input type="date" className="fs-5 border-0 text-black" />
                    </div> */}
                    </div>
                    <Row>
                      <div className="mb-3 row">
                      <Label
                          htmlFor="stockID"
                          className="col-lg-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">{this.props.t('Stock ID')}</h5>
                        </Label>
                        <div className="col-lg-7 col-12">
                          <Field
                            className={
                              "form-control form-select fs-5" +
                              (errors.stockID && touched.stockID
                                ? " is-invalid"
                                : "")
                            }
                            name="stockID"
                            as="select"
                          >
                            <option value="" disabled>
                              select
                            </option>
                            <option value="STOCK0000123">STOCK0000123</option>
                            <option value="STOCK0000123">STOCK0000123</option>
                            <option value="STOCK0000123">STOCK0000123</option>
                            <option value="STOCK0000123">STOCK0000123</option>
                          </Field>
                          <ErrorMessage
                            name="stockID"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <Label
                          htmlFor="partyCode"
                          className="col-lg-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                            {this.props.t('Party Name')}
                          </h5>
                        </Label>
                        <div className="col-lg-7 col-12">
                          <Field
                            className={
                              "form-control fs-5" +
                              (errors.partyCode && touched.partyCode
                                ? " is-invalid"
                                : "")
                            }
                            type="text"
                            name="partyCode"
                            placeholder="XYZ Diamond"
                          />
                          <ErrorMessage
                            name="partyCode"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <Label
                          htmlFor="unitName"
                          className="col-lg-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">{this.props.t('Unit Name')}</h5>
                        </Label>
                        <div className="col-lg-7 col-12">
                          <Field
                            className={
                              "form-control form-select fs-5" +
                              (errors.unitName && touched.unitName
                                ? " is-invalid"
                                : "")
                            }
                            name="unitName"
                            as="select"
                          >
                            <option value="" disabled>
                              select
                            </option>
                            <option value="xyz">ABC Diamond Unit</option>
                            <option value="xyz">ABC Diamond Unit</option>
                            <option value="xyz">ABC Diamond Unit</option>
                            <option value="xyz">ABC Diamond Unit</option>
                          </Field>
                          <ErrorMessage
                            name="unitName"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <Label
                          htmlFor="weight"
                          className="col-lg-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">{this.props.t('Total Weight')}</h5>
                        </Label>
                        <div className="col-lg-7 col-12">
                          <Field
                            className={
                              "form-control fs-5" +
                              (errors.weight && touched.weight
                                ? " is-invalid"
                                : "")
                            }
                            type="text"
                            name="weight"
                            placeholder="20.25 CT"
                          />
                          <ErrorMessage
                            name="weight"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <Label
                          htmlFor="pieces"
                          className="col-lg-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                            {this.props.t('Total No of Pieces')}
                          </h5>
                        </Label>
                        <div className="col-lg-7 col-12">
                          <Field
                            className={
                              "form-control fs-5" +
                              (errors.pieces && touched.pieces
                                ? " is-invalid"
                                : "")
                            }
                            type="text"
                            name="pieces"
                            placeholder="01%"
                          />
                          <ErrorMessage
                            name="pieces"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <Label
                          htmlFor="graderName"
                          className="col-lg-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                          {this.props.t("Grader Name")}
                          </h5>
                        </Label>
                        <div className="col-lg-7 col-12">
                          <Field
                            className={
                              "form-control form-select fs-5" +
                              (errors.graderName && touched.graderName
                                ? " is-invalid"
                                : "")
                            }
                            name="graderName"
                            as="select"
                          >
                            <option value="" disabled>
                              select
                            </option>
                            <option value="name1">Greder 1</option>
                            <option value="name2">Greder 2</option>
                            <option value="name3">Greder 3</option>
                            <option value="name4">Greder 4</option>
                          </Field>
                          <ErrorMessage
                            name="graderName"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>


                      <div className="row px-3 pt-4">
                        <div>
                          <h3 className="fw-bold pb-3 text-black">
                          {this.props.t('Outward Stock Summary')}
                          </h3>
                        </div>

                        <div className="table-responsive">
                          <BootstrapTable
                            classes="foo"
                            keyField="id"
                            headerClasses="background-light fs-5"
                            footerClasses="background-light fs-5"
                            bootstrap4={true}
                            data={this.products2}
                            columns={this.columns2}
                          />
                        </div>
                      </div>

                      <div className="mb-3 row px-3 pt-3">
                        <Label
                          htmlFor="inwardnotes"
                          className="col-md-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                          Self Internal Remarks
                          </h5>
                        </Label>
                        <div className="col-md-10">
                          <Field
                            className={
                              "form-control fs-5" +
                              (errors.inwardnotes && touched.inwardnotes
                                ? " is-invalid"
                                : "")
                            }
                            type="text"
                            name="inwardnotes"
                            as="textarea"
                            rows="5"
                          />
                          <ErrorMessage
                            name="inwardnotes"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                      <div className="mb-3 row px-3 pt-3">
                        <Label
                          htmlFor="outwardnotes"
                          className="col-md-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                          {this.props.t('For Next Person Remarks')}
                          </h5>
                        </Label>
                        <div className="col-md-10">
                          <Field
                            className={
                              "form-control fs-5" +
                              (errors.outwardnotes && touched.outwardnotes
                                ? " is-invalid"
                                : "")
                            }
                            type="text"
                            name="outwardnotes"
                            as="textarea"
                            rows="5"
                          />
                          <ErrorMessage
                            name="outwardnotes"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>

                      <div className="col-md-12 text-center text-md-end pe-3 py-5">
                        <Button
                          color="primary"
                          className="fs-4 px-5"
                          type="submit"
                        >
                          Submit
                        </Button>
                      </div>
                    </Row>
                  </Form>
                )}
              </Formik>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(DataEntryEditOutwardStock);
